// extracted by mini-css-extract-plugin
module.exports = {"icon":"FavoriteSearchActionButton_icon__-hhch","trigger":"FavoriteSearchActionButton_trigger__2FOlV","activeTrigger":"FavoriteSearchActionButton_activeTrigger__2iQ9l"};